(function () {
  if (window.__bfCartDrawerRefreshFix) return;
  window.__bfCartDrawerRefreshFix = true;

  var partIds = [
    'MinimogCartDrawerHeader',
    'MinimogCartDrawerBody',
    'MinimogCartDrawerFooter'
  ];

  function replaceDrawerParts(html) {
    if (!html) return false;
    var nextDocument = new DOMParser().parseFromString(html, 'text/html');
    var updated = false;

    partIds.forEach(function (id) {
      var currentPart = document.getElementById(id);
      var nextPart = nextDocument.getElementById(id);
      if (currentPart && nextPart) {
        currentPart.innerHTML = nextPart.innerHTML;
        updated = true;
      }
    });

    return updated;
  }

  function openDrawer() {
    var drawer = document.querySelector('m-cart-drawer');
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else drawer.classList.add('m-cart-drawer--active');
  }

  function updateCount(cart) {
    if (!cart || !Number.isFinite(Number(cart.item_count))) return;
    document.querySelectorAll('m-cart-count').forEach(function (count) {
      count.textContent = String(cart.item_count);
    });
  }

  function refreshDrawer() {
    return Promise.all([
      fetch('/?sections=cart-drawer,cart-count&_=' + Date.now(), { cache: 'no-store' }).then(function (response) {
        return response.json();
      }),
      fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (response) {
        return response.json();
      })
    ]).then(function (results) {
      var sections = results[0] || {};
      var cart = results[1] || {};
      replaceDrawerParts(sections['cart-drawer']);
      updateCount(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      openDrawer();
    }).catch(function (error) {
      console.error('BrideFits cart drawer refresh failed', error);
    });
  }

  document.addEventListener('product-ajax:added', function (event) {
    var response = event.detail && (event.detail.product || event.detail.cart);
    var drawerHtml = response && response.sections && response.sections['cart-drawer'];

    if (replaceDrawerParts(drawerHtml)) {
      updateCount(response);
      openDrawer();
    } else {
      refreshDrawer();
    }
  });
})();
